import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.simple-input */
import React, { useEffect, useState } from 'react';
import { useThemeUI } from 'theme-ui';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export var SimpleInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var hasError = props.hasError,
      type = props.type,
      placeholder = props.placeholder,
      onChange = props.onChange,
      name = props.name,
      defaultValue = props.defaultValue,
      prefix = props.prefix,
      suffix = props.suffix,
      inputSize = props.inputSize,
      uppercase = props.uppercase,
      onKeyDown = props.onKeyDown;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      prefixWidth = _useState4[0],
      setPrefixWidth = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      suffixWidth = _useState6[0],
      setSuffixWidth = _useState6[1];

  var prefixRef = /*#__PURE__*/React.createRef();
  var suffixRef = /*#__PURE__*/React.createRef();

  var additionalProps = function additionalProps() {
    var defaultProps = ['hasError', 'type', 'placeholder', 'onChange', 'name', 'defaultValue', 'prefix', 'suffix', 'uppercase', 'onKeyDown', 'inputSize'];
    var tempArr = {};
    Object.keys(props).forEach(function (key) {
      if (!defaultProps.includes(key)) {
        tempArr = _objectSpread(_objectSpread({}, tempArr), {}, _defineProperty({
          'aria-label': name
        }, key, props[key]));
      }
    });
    return tempArr;
  };

  useEffect(function () {
    var _prefixRef$current, _suffixRef$current;

    setPrefixWidth((prefixRef === null || prefixRef === void 0 ? void 0 : (_prefixRef$current = prefixRef.current) === null || _prefixRef$current === void 0 ? void 0 : _prefixRef$current.offsetWidth) || 0);
    setSuffixWidth((suffixRef === null || suffixRef === void 0 ? void 0 : (_suffixRef$current = suffixRef.current) === null || _suffixRef$current === void 0 ? void 0 : _suffixRef$current.offsetWidth) || 0);
  }, [prefixRef, suffixRef]);

  var setWidth = function setWidth(inputSize) {
    var _theme$elements, _theme$elements$simpl, _theme$elements$simpl2;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _useThemeUI = useThemeUI(),
        theme = _useThemeUI.theme;

    var widthLookup = {
      sm: theme === null || theme === void 0 ? void 0 : (_theme$elements = theme.elements) === null || _theme$elements === void 0 ? void 0 : (_theme$elements$simpl = _theme$elements['simple-input']) === null || _theme$elements$simpl === void 0 ? void 0 : (_theme$elements$simpl2 = _theme$elements$simpl.inputWidth) === null || _theme$elements$simpl2 === void 0 ? void 0 : _theme$elements$simpl2.small,
      base: '100%'
    };
    return inputSize ? widthLookup[inputSize] + prefixWidth + suffixWidth : widthLookup.base;
  };

  return _jsxs("div", {
    onBlur: function onBlur() {
      return setHasFocus(false);
    },
    sx: {
      width: setWidth(inputSize),
      variant: hasError && !hasFocus ? 'elements.simple-input.variants.error' : hasFocus ? 'elements.simple-input.variants.focus' : 'elements.simple-input.wrapper'
    },
    children: [prefix ? _jsx("span", {
      ref: prefixRef,
      sx: {
        variant: 'elements.simple-input.affix.prefix'
      },
      children: prefix
    }) : null, _jsx("input", _objectSpread({
      sx: {
        variant: 'elements.simple-input.base',
        textAlign: inputSize === 'sm' ? 'center' : 'left',
        textTransform: uppercase && 'uppercase'
      },
      placeholder: placeholder,
      ref: ref,
      onChange: onChange,
      defaultValue: defaultValue,
      onFocus: function onFocus() {
        setHasFocus(false);
        setHasFocus(true);
      },
      onBlur: function onBlur() {
        return setHasFocus(false);
      },
      onKeyDown: onKeyDown,
      name: name,
      type: type || 'text'
    }, additionalProps())), suffix ? _jsx("span", {
      ref: suffixRef,
      sx: {
        variant: 'elements.simple-input.affix.suffix'
      },
      children: suffix
    }) : null]
  });
});
//# sourceMappingURL=index.js.map